module.exports = __webpack_public_path__ + "img/Check.8d387bac.svg";